import { render, staticRenderFns } from "./NFLSeasonalStatistics.vue?vue&type=template&id=09d468d1&"
import script from "./NFLSeasonalStatistics.vue?vue&type=script&lang=js&"
export * from "./NFLSeasonalStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports